import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateBiStatus = createAsyncThunk("updateBiStatus", async ({ id, data }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};
	const response = await axiosHttp.patch(`bi/updatestatus?id=${id}`, data, config);
	message.success("Updated successfully!");
	return response.data;
});

const updateBiStatusSlice = createSlice({
	name: "updateBiStatus",
	initialState: {
		isLoading: false,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(updateBiStatus.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(updateBiStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(updateBiStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default updateBiStatusSlice.reducer;
